module.exports = __webpack_public_path__ + "img/fl88.3764254.webp";